import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';
import { LogisticService } from '../../../services/logistic.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-stock-transfer-create',
  templateUrl: './stock-transfer-create.component.html',
  styleUrls: ['./stock-transfer-create.component.css']
})
export class StockTransferCreateComponent implements OnInit {
    stockPlaceId;

    public itemsListTrolleys: Item[] = [];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService) {
        this.stockPlaceId = this.stateService.getStateParams()['stockplace_id'];
    }

    private async loadTrolleys() {
        if (!!this.stockPlaceId) {
            this.itemsListTrolleys = await this.logistic.getTrolleys({ stockplace_id: this.stockPlaceId });
        }
    }

    goToPrevious = async (item: Item) => {
        if (!!this.itemsListTrolleys) {
            const response = (await this.datatask.Post(1059, { stocklocation_keyno_trolley: item.item_id }))[0];

            if (response?.errorcode !== '0') {
                this.modal.show({
                    type: 'warning',
                    title: 'error',
                    translateTitle: true,
                    message: response.errormessage
                });
            } else {
                this.stateService.back();
            }
        }
    }

    private async init() {
        this.loadTrolleys();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockTransferCreate', {
//        templateUrl: 'views/components/views/stockTransferCreate/stockTransferCreate.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'stockTransferCreateService', 'logisticService', function ($stateParams, stateService, translateService, modalService, stockTransferCreateService, logisticService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockPlaceId = $stateParams.stockplace_id;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                itemsListTrolleys: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE CALLS

//            async function loadTrolleys() {
//                vm.model.itemsListTrolleys = await logisticService.listTrolleys({ stockplace_id: stockPlaceId });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region SAVE ITEM AND NAVIGATE PREVIOUS

//            vm.goToPrevious = function (item) {
//                stockTransferCreateService.saveToPrevious({ stocklocation_keyno_trolley: item.item_id }).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                }
//                            }]
//                        });
//                    } else {
//                        stateService.back();
//                    }
//                });
//            };

//            // #region SAVE ITEM AND NAVIGATE PREVIOUS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadTrolleys();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
